module.exports = __webpack_public_path__ + "img/hr-sand-decal-20.ea95cf30.png";